export {default} from './OtaAccountListModel';
export {OtaAccountsListModelType} from './OtaAccountListModel';



// WEBPACK FOOTER //
// ./src/models/OtaAccountsListModel/index.ts